import React from 'react'
import { token } from '@planningcenter/tapestry'
import { Heading } from '@planningcenter/tapestry-react'

const Headline = ({ level = 1, ...props }) => {
  const styles = {
    margin: '0 0 16px',
    color: token('--t-text-color-headline'),
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '200',
    ...(level === 2 && {
      color: token('--t-text-color'),
      fontSize: '14px',
      fontWeight: '700',
      lineHeight: '16px',
    }),
  }
  return <Heading css={styles} {...props} />
}

export default Headline
